import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function input(theme: Theme): ComponentStyle {
  return {
    componentName: 'input',
    variants: {
      textSearchFilter: {
        backgroundColor: theme.colors.onSurface,
        border: `solid 1px ${theme.colors.border}`,

        ['&:focus']: {
          borderColor: theme.colors.spark.purple4
        }
      }
    }
  };
}
